module.exports = __webpack_public_path__ + "static/media/vertical-bars.34c82e5c.jpg";